// NoDataFound.tsx
import React from "react";

interface NoDataFoundProps {
  message?: string;
  style?: React.CSSProperties;
}

const NoDataFound: React.FC<NoDataFoundProps> = ({
  message = "No data found",
  style = {},
}) => {
  return (
    <div
      style={{
        marginTop: 35,
        textAlign: "center",
        color: "#666",
        fontSize: 16,
        ...style,
      }}
    >
      <p>{message}</p>
    </div>
  );
};

export default NoDataFound;
